<template>
  <div class="sticky top-14 z-30 bg-white border-b border-gray-200">
    <div class="max-w-[1400px] mx-auto px-4 py-2.5">
      <div class="flex items-center gap-3 flex-wrap">
        <!-- Date inputs -->
        <div class="flex items-center gap-2">
          <label class="text-xs font-medium text-gray-500">Du</label>
          <input
            type="date"
            :value="dateFrom"
            @input="dateFrom = $event.target.value"
            class="px-2.5 py-1.5 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none bg-gray-50"
          />
        </div>
        <div class="flex items-center gap-2">
          <label class="text-xs font-medium text-gray-500">Au</label>
          <input
            type="date"
            :value="dateTo"
            @input="dateTo = $event.target.value"
            class="px-2.5 py-1.5 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none bg-gray-50"
          />
        </div>

        <!-- Separator -->
        <div class="hidden sm:block w-px h-6 bg-gray-200"></div>

        <!-- Presets -->
        <div class="flex items-center gap-1.5 flex-wrap">
          <button
            v-for="p in presets"
            :key="p.key"
            @click="setPreset(p.key)"
            class="px-2.5 py-1 text-xs font-medium rounded-lg transition-colors"
            :class="isActivePreset(p.key) ? 'bg-primary text-white' : 'text-gray-500 hover:bg-gray-100'"
          >
            {{ p.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDateRange } from '@/composables/useDateRange'

const { dateFrom, dateTo, setPreset } = useDateRange()

const presets = [
  { key: 'today', label: "Aujourd'hui" },
  { key: 'week', label: 'Cette semaine' },
  { key: 'month', label: 'Ce mois' },
  { key: 'quarter', label: 'Ce trimestre' },
  { key: 'year', label: "Cette annee" }
]

function isActivePreset(key) {
  const now = new Date()
  const from = dateFrom.value
  const to = dateTo.value

  const fmt = (d) => {
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${dd}`
  }

  switch (key) {
    case 'today':
      return from === fmt(now) && to === fmt(now)
    case 'month':
      return from === fmt(new Date(now.getFullYear(), now.getMonth(), 1)) &&
             to === fmt(new Date(now.getFullYear(), now.getMonth() + 1, 0))
    default:
      return false
  }
}
</script>
